import i18n from 'i18next'

import { PatchStrategy, SelectOption } from './types'

const strategyDescriptionI18nKeys = {
  priority: i18n.t(
    'The predicted class for overlapping patches is decided based on class order priority'
  ),
  major_voting: i18n.t(
    'The predicted class for overlapping patches is decided based on the most frequent class'
  ),
}

export const patchStrategyToOption = () => (
  patchStrategy: PatchStrategy
): SelectOption => ({
  value: patchStrategy.id.toString(),
  label: patchStrategy.name,
  description:
    patchStrategy.code in strategyDescriptionI18nKeys
      ? strategyDescriptionI18nKeys[
          patchStrategy.code as keyof typeof strategyDescriptionI18nKeys
        ]
      : patchStrategy.description,
})
